import { sanitizePostHogCaptureResult } from '@tebuto/lib/posthog-privacy'
import posthog from 'posthog-js'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: '/ingest',
    ui_host: 'https://eu.posthog.com',
    defaults: '2026-01-30',
    autocapture: false,
    capture_pageview: 'history_change',
    capture_pageleave: false,
    capture_exceptions: false,
    capture_performance: false,
    capture_heatmaps: false,
    capture_dead_clicks: false,
    person_profiles: 'never',
    mask_personal_data_properties: true,
    disable_surveys: true,
    disable_session_recording: true,
    opt_out_capturing_by_default: true,
    opt_out_capturing_persistence_type: 'cookie',
    opt_out_persistence_by_default: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
    before_send: sanitizePostHogCaptureResult,
    property_denylist: [
        'email',
        'name',
        'first_name',
        'last_name',
        'phone',
        'address',
        'client_id',
        'booking_id',
        'therapist_id',
        'payment_method_id',
        'invitation_link_id',
        'gross_amount',
        'tax_rate',
        'price',
        'amount'
    ],
    debug: process.env.NODE_ENV === 'development'
})
